import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import "./NavBar.css";
import { URL_Back } from "../Pages/Variables";
import Menu from "../../Model/Menu";
import { withTranslation } from "react-i18next";
import cookies from "js-cookie";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";


const NavBar = (props) => {

  const { t, i18n } = props
  const [items, setItems] = useState([]);
  const [menus, setMenus] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [classNameNavBar, setClassNameNavBar] = useState("");
  const [classLogo, setClassLogo] = useState("logo");
  const [expanded, setExpanded] = useState(false);
  const [langue, setLangue] = useState("fr");
  const [url, setUrl] = useState("");
  const flagImages = {
    fr: '/images/france 1.png',
    en: '/images/anglais.png',
    ar: '/images/arabe.png',
  };
  const languesDisponibles = [
    { code: "fr", label: "FR", image: flagImages.fr },
    { code: "en", label: "EN", image: flagImages.en },
    { code: "ar", label: "AR", image: flagImages.ar }
  ];
  const languesAffichees = languesDisponibles.filter((item) => item.code !== langue);

  var verif = false;

  const [menuItems, setMenuItems] = useState([])

  const currentLanguage = cookies.get('i18next') || 'fr'

  const openMenuAPropos = (valeur) => {
    menuItems.map(element => { element.db_id === valeur && (element.verif = true) })
    return setMenuItems([...menuItems]);
  }

  const closeMenuAPropos = () => {
    menuItems.map(element => { element.verif = false })
    return setMenuItems([...menuItems]);
  }

  const ChangeLangue = (val) => {
    val !== langue &&
      (setLangue(val), i18n.changeLanguage(val), localStorage.setItem("lng", val), document.documentElement.setAttribute("lang", val))

    document.body.dir = val === 'ar' ? 'rtl' : 'ltr'

    val === "en"
      ? fetch(`${URL_Back}/wp-json/menus/v1/menus/95`)
        .then(res => res.json())
        .then(
          (result) => {
            let menuTabs = [];
            setMenus(result);
            result.items.map(element =>
              menuTabs.push(new Menu(element.db_id, element.title, element.child_items, element.slug, verif))
            )
            setMenuItems(menuTabs)
          },
          (error) => {
            console.log(error);
          }
        )
      : val === "fr"
        ? fetch(`${URL_Back}/wp-json/menus/v1/menus/95`)
          .then(res => res.json())
          .then(
            (result) => {
              let menuTabs = [];
              setMenus(result);
              result.items.map(element =>
                menuTabs.push(new Menu(element.db_id, element.title, element.child_items, element.slug, verif))
              )
              setMenuItems(menuTabs)
            },
            (error) => {
              console.log(error);
            }
          )
        : fetch(`${URL_Back}/wp-json/menus/v1/menus/95`)
          .then(res => res.json())
          .then(
            (result) => {
              let menuTabs = [];
              setMenus(result);
              result.items.map(element =>
                menuTabs.push(new Menu(element.db_id, element.title, element.child_items, element.slug, verif))
              )
              setMenuItems(menuTabs)
            },
            (error) => {
              console.log(error);
            }
          )

    const title = decodeURI(window.location.pathname)

    if (val === "en" && (title === "/fr/notre-agence" || title === "/ar/وكالتنا"))
      window.location.href = "/en/our-agency"
    if (val === "fr" && (title === "/en/our-agency" || title === "/ar/وكالتنا"))
      window.location.href = "/fr/notre-agence"
    if (val === "ar" && (title === "/en/our-agency" || title === "/fr/notre-agence"))
      window.location.href = "/ar/وكالتنا"
    if (val === "en" && (title === "/fr/notre-equipe" || title === "/ar/فريقنا"))
      window.location.href = "/en/our-team"
    if (val === "fr" && (title === "/en/our-team" || title === "/ar/فريقنا"))
      window.location.href = "/fr/notre-equipe"
    if (val === "ar" && (title === "/en/our-team" || title === "/fr/notre-equipe"))
      window.location.href = "/ar/فريقنا"
    if (val === "en" && (title === "/fr/nos-services" || title === "/ar/تطوير-الويب"))
      window.location.href = "/en/web-development"
    if (val === "fr" && (title === "/en/web-development" || title === "/ar/تطوير-الويب"))
      window.location.href = "/fr/nos-services"
    if (val === "ar" && (title === "/en/web-development" || title === "/fr/nos-services"))
      window.location.href = "/ar/تطوير-الويب"
    if (val === "en" && (title === "/fr/developpement-mobile" || title === "/ar/تطوير-المحمول"))
      window.location.href = "/en/mobile-development"
    if (val === "fr" && (title === "/en/mobile-development" || title === "/ar/تطوير-المحمول"))
      window.location.href = "/fr/developpement-mobile"
    if (val === "ar" && (title === "/en/mobile-development" || title === "/fr/developpement-mobile"))
      window.location.href = "/ar/تطوير-المحمول"
    if (val === "en" && title === "/ar/إدارة-المجتمع")
      window.location.href = "/en/community-management"
    if (val === "fr" && title === "/ar/إدارة-المجتمع")
      window.location.href = "/fr/community-management"
    if (val === "ar" && (title === "/en/community-management" || title === "/fr/community-management"))
      window.location.href = "/ar/إدارة-المجتمع"
    if (val === "en" && title === "/ar/محرك-البحث-الأمثل")
      window.location.href = "/en/search-engine-optimization"
    if (val === "fr" && title === "/ar/محرك-البحث-الأمثل")
      window.location.href = "/fr/search-engine-optimization"
    if (val === "ar" && (title === "/en/search-engine-optimization" || title === "/fr/search-engine-optimization"))
      window.location.href = "/ar/محرك-البحث-الأمثل"
    if (val === "en" && (title === "/fr/service-de-consultation" || title === "/ar/خدمة-استشارية"))
      window.location.href = "/en/service-provision"
    if (val === "fr" && (title === "/en/service-provision" || title === "/ar/خدمة-استشارية"))
      window.location.href = "/fr/service-de-consultation"
    if (val === "ar" && (title === "/en/service-provision" || title === "/fr/service-de-consultation"))
      window.location.href = "/ar/خدمة-استشارية"
    if (val === "en" && (title === "/fr/prestation-de-service" || title === "/ar/تقديم-الخدمة"))
      window.location.href = "/en/service-delivery"
    if (val === "fr" && (title === "/en/service-delivery" || title === "/ar/تقديم-الخدمة"))
      window.location.href = "/fr/prestation-de-service"
    if (val === "ar" && (title === "/en/service-delivery" || title === "/fr/prestation-de-service"))
      window.location.href = "/ar/تقديم-الخدمة"
    if (val === "en" && (title === "/ar/مَلَفّ" || title === "/fr/nos-references"))
      window.location.href = "/en/portfolio"
    if (val === "fr" && (title === "/ar/مَلَفّ" || title === "/en/portfolio"))
      window.location.href = "/fr/nos-references"
    if (val === "ar" && (title === "/en/portfolio" || title === "/fr/nos-references"))
      window.location.href = "/ar/مَلَفّ"
    if (val === "en" && (title === "/fr/nos-offres-demplois" || title === "/ar/عروض-عملنا"))
      window.location.href = "/en/our-job-offers"
    if (val === "fr" && (title === "/en/our-job-offers" || title === "/ar/عروض-عملنا"))
      window.location.href = "/fr/nos-offres-demplois"
    if (val === "ar" && (title === "/en/our-job-offers" || title === "/fr/nos-offres-demplois"))
      window.location.href = "/fr/nos-offres-demplois"
    if (val === "en" && title === "/fr/recrutement" || title === "/ar/توظيف")
      window.location.href = "/en/recruiting"
    if (val === "fr" && title === "/en/recruiting" || title === "/ar/توظيف")
      window.location.href = "/fr/recrutement"
    if (val === "ar" && title === "/en/recruiting" || title === "/fr/recrutement")
      window.location.href = "/ar/توظيف"
    if (val === "en" && (title === "/fr/contact" || title === "/ar/اتصل-بنا"))
      window.location.href = "/en/contact-us"
    if (val === "fr" && (title === "/en/contact-us" || title === "/ar/اتصل-بنا"))
      window.location.href = "/fr/contact"
    if (val === "ar" && (title === "/en/contact-us" || title === title === "/fr/contact"))
      window.location.href = "/fr/contact"
    if (val === "en" && (title === "/fr/notre-solution-bowling" || title === "/ar/حل-البولينج-لدينا"))
      window.location.href = "/en/our-bowling-solution"
    if (val === "fr" && (title === "/en/our-bowling-solution" || title === "/ar/حل-البولينج-لدينا"))
      window.location.href = "/fr/notre-solution-bowling"
    if (val === "ar" && (title === "/en/our-bowling-solution" || title === "/fr/notre-solution-bowling"))
      window.location.href = "/ar/حل-البولينج-لدينا"

    if (val === "en" && (title === "/fr/mentions-legales" || title === "/ar/تعليمات-الاستخدام"))
      window.location.href = "/en/terms-of-use"
    if (val === "fr" && (title === "/en/terms-of-use" || title === "/ar/تعليمات-الاستخدام"))
      window.location.href = "/fr/mentions-legales"
    if (val === "ar" && (title === "/en/terms-of-use" || title === "/fr/mentions-legales"))
      window.location.href = "/ar/تعليمات-الاستخدام"

    if (val === "en" && (title === "/fr/notre-solution-bowling/bowling-de-limoges" || title === "/ar/حل-البولينج-لدينا/bowling-de-limoges"))
      window.location.href = "/en/our-bowling-solution/bowling-de-limoges"
    if (val === "fr" && (title === "/en/our-bowling-solution/bowling-de-limoges" || title === "/ar/حل-البولينج-لدينا/bowling-de-limoges"))
      window.location.href = "/fr/notre-solution-bowling/bowling-de-limoges"
    if (val === "ar" && (title === "/en/our-bowling-solution/bowling-de-limoges" || title === "/fr/notre-solution-bowling/bowling-de-limoges"))
      window.location.href = "/ar/حل-البولينج-لدينا/bowling-de-limoges"
    if (val === "en" && (title === "/fr/notre-solution-bowling/space-bowling" || title === "/ar/حل-البولينج-لدينا/space-bowling"))
      window.location.href = "/en/our-bowling-solution/space-bowling"
    if (val === "fr" && (title === "/en/our-bowling-solution/space-bowling" || title === "/ar/حل-البولينج-لدينا/space-bowling"))
      window.location.href = "/fr/notre-solution-bowling/space-bowling"
    if (val === "ar" && (title === "/en/our-bowling-solution/space-bowling" || title === "/fr/notre-solution-bowling/space-bowling"))
      window.location.href = "/ar/حل-البولينج-لدينا/space-bowling"
    if (val === "en" && (title === "/fr/notre-solution-bowling/extra-laser-bowling" || title === "/ar/حل-البولينج-لدينا/extra-laser-bowling"))
      window.location.href = "/en/our-bowling-solution/extra-laser-bowling"
    if (val === "fr" && (title === "/en/our-bowling-solution/extra-laser-bowling" || title === "/ar/حل-البولينج-لدينا/extra-laser-bowling"))
      window.location.href = "/fr/notre-solution-bowling/extra-laser-bowling"
    if (val === "ar" && (title === "/en/our-bowling-solution/extra-laser-bowling" || title === "/fr/notre-solution-bowling/extra-laser-bowling"))
      window.location.href = "/ar/حل-البولينج-لدينا/extra-laser-bowling"
    if (val === "en" && (title === "/fr/notre-solution-bowling/planet-bowling" || title === "/ar/حل-البولينج-لدينا/planet-bowling"))
      window.location.href = "/en/our-bowling-solution/planet-bowling"
    if (val === "fr" && (title === "/en/our-bowling-solution/planet-bowling" || title === "/ar/حل-البولينج-لدينا/planet-bowling"))
      window.location.href = "/fr/notre-solution-bowling/planet-bowling"
    if (val === "ar" && (title === "/en/our-bowling-solution/planet-bowling" || title === "/fr/notre-solution-bowling/planet-bowling"))
      window.location.href = "/ar/حل-البولينج-لدينا/planet-bowling"
    if (val === "en" && (title === "/fr/notre-solution-bowling/bowling-de-limoges" || title === "/ar/حل-البولينج-لدينا/bowling-de-limoges"))
      window.location.href = "/en/our-bowling-solution/bowling-de-limoges"
    if (val === "fr" && (title === "/en/our-bowling-solution/bowling-de-limoges" || title === "/ar/حل-البولينج-لدينا/bowling-de-limoges"))
      window.location.href = "/fr/notre-solution-bowling/bowling-de-limoges"
    if (val === "ar" && (title === "/en/our-bowling-solution/bowling-de-limoges" || title === "/fr/notre-solution-bowling/bowling-de-limoges"))
      window.location.href = "/ar/حل-البولينج-لدينا/bowling-de-limoges"
  }

  const title = window.location.pathname
  const splitState = title.split("/")

  useEffect(() => {
    splitState.length === 1 ? setUrl("")
      : (splitState[1].length === 2) ?
        splitState.length === 3 ? setUrl("/" + splitState[2])
          : splitState.length === 4 ? setUrl("/" + splitState[2] + "/" + splitState[3])
            : setUrl("")
        : splitState.length === 2 ? setUrl("/" + splitState[1])
          : splitState.length === 3 ? setUrl("/" + splitState[1] + "/" + splitState[2]) : setUrl("")

  }, [splitState.length])

  useEffect(() => {
    setLangue(currentLanguage)
    i18n.changeLanguage(currentLanguage)
    localStorage.setItem("lng", currentLanguage)
    document.documentElement.setAttribute("lang", currentLanguage)

    if (currentLanguage === "en") {
      fetch(`${URL_Back}/wp-json/menus/v1/menus/95`)
        .then(res => res.json())
        .then(
          (result) => {
            let menuTabs = [];
            setMenus(result);
            result.items.map(element =>
              menuTabs.push(new Menu(element.db_id, element.title, element.child_items, element.slug, verif))
            )
            setMenuItems(menuTabs)
          },
          (error) => {
            console.log(error);
          }
        )
    } else if (currentLanguage === "fr") {
      fetch(`${URL_Back}/wp-json/menus/v1/menus/95`)
        .then(res => res.json())
        .then(
          (result) => {
            let menuTabs = [];
            setMenus(result);
            result.items.map(element =>
              menuTabs.push(new Menu(element.db_id, element.title, element.child_items, element.slug, verif))
            )
            setMenuItems(menuTabs)
          },
          (error) => {
            console.log(error);
          }
        )
    } else {
      fetch(`${URL_Back}/wp-json/menus/v1/menus/95`)
        .then(res => res.json())
        .then(
          (result) => {
            let menuTabs = [];
            setMenus(result);
            result.items.map(element =>
              menuTabs.push(new Menu(element.db_id, element.title, element.child_items, element.slug, verif))
            )
            setMenuItems(menuTabs)
          },
          (error) => {
            console.log(error);
          }
        )
        , [currentLanguage]
    }

    const onScroll = e => {
      if (e.target.documentElement.scrollTop < 100) {
        setClassNameNavBar("");
        setClassLogo("logo")
      } else if (e.target.documentElement.scrollTop > 120) {
        setClassNameNavBar("backgroundSizeAndColor");
        setClassLogo("logoBackground")
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [])
  const location = useLocation();
  const isHome = location.pathname === '/' || location.pathname === '/fr' || location.pathname === '/en' || location.pathname === '/ar';
  return (
    <>
      <Navbar expand="lg" className={langue === "ar" ? `${classNameNavBar} navbar-ar` : `${classNameNavBar}`} id="navbar" expanded={expanded}>
        <Nav.Link as={Link} to={"/" + langue} className="nav-logo">
          <img className={`${classLogo}`} src="/images/oxton.png" alt="oxton" />
        </Nav.Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="lignes" onClick={() => setExpanded(expanded ? false : "expanded")} >
          <span className="my-1 mx-2 close">
            <img src="/images/navbar/close.svg" alt="close" />
          </span>
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto">
            {menuItems.map(item => (
              item.title !== "Espace client" && item.title !== "Langues" ? (
                item.child_items ? (
                  window.innerWidth > 991 ? (
                    <NavDropdown
                      key={item.db_id}
                      title={item.title}
                      className={`menu with_dropdown ${location.pathname.includes(item.slug) ? 'active' : ''}`} // Apply active class
                      show={item.verif}
                      onMouseEnter={() => openMenuAPropos(item.db_id)}
                      onMouseLeave={closeMenuAPropos}
                      onClick={() => item.verif ? closeMenuAPropos() : openMenuAPropos(item.db_id)}
                    >
                      {item.child_items.map(child => (
                        <NavDropdown.Item
                          as={Link}
                          to={`/${langue}/${child.slug}`}
                          key={child.db_id}
                          onClick={() => { setExpanded(false); closeMenuAPropos(); }}
                          className={location.pathname === `/${langue}/${child.slug}` ? 'active' : ''} // Apply active class
                        >
                          {child.title}
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>
                  ) : (
                    <NavDropdown
                      key={item.db_id}
                      title={item.title}
                      className={`menu with_dropdown menu_mobile ${langue === 'ar' ? 'menu_mobile-ar' : ''} ${location.pathname.includes(item.slug) ? 'active' : ''}`} // Apply active class
                    >
                      {item.child_items.map(child => (
                        <NavDropdown.Item
                          as={Link}
                          to={`/${langue}/${child.slug}`}
                          key={child.db_id}
                          onClick={() => { setExpanded(false); closeMenuAPropos(); }}
                          className={location.pathname === `/${langue}/${child.slug}` ? 'active' : ''} 
                        >
                          {child.title}
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>
                  )
                ) : (
                  <Nav.Link
                    key={item.db_id}
                    as={Link}
                    to={`/${langue}/${item.slug}`}
                    onClick={() => setExpanded(false)}
                    className={`menu without-dropdown ${location.pathname === `/${langue}/${item.slug}` ? 'active' : ''}`} // Apply active class
                  >
                    <Nav.Item className="title_without_dropdown">{item.title}</Nav.Item>
                  </Nav.Link>
                )
              ) : null
            ))}
          </Nav>

          <Nav className="d-flex align-items-center gap-3" style={{ position: 'static !important' }}>
            <Nav.Link style={{ paddingRight: 0 }} as={Link} to={"/" + langue + (langue === "fr" ? "/notre-solution-bowling" : langue === "en" ? "/our-bowling-solution" : "/حل-البولينج-لدينا")} >
              {/* <button className={langue === "ar" ? "btn btn-primary button button-ar buttonNav" : "btn btn-primary button buttonNav"} type="submit" onClick={() => setExpanded(false)}>
                <span className="pseudo-text d-flex gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="25" viewBox="0 0 20 25" fill="none">
<path d="M10.0004 11.5789C11.5911 11.5789 12.9683 11.0084 14.0939 9.88276C15.2192 8.75729 15.7899 7.38021 15.7899 5.78929C15.7899 4.19892 15.2194 2.82166 14.0938 1.69582C12.9681 0.57053 11.5909 0 10.0004 0C8.40954 0 7.0325 0.57053 5.90707 1.696C4.78163 2.82147 4.21094 4.19874 4.21094 5.78929C4.21094 7.38021 4.78163 8.75747 5.90707 9.88295C7.03287 11.0082 8.41009 11.5789 10.0004 11.5789ZM6.90322 2.692C7.76678 1.82841 8.7798 1.40863 10.0004 1.40863C11.2208 1.40863 12.234 1.82841 13.0978 2.692C13.9613 3.55577 14.3813 4.56901 14.3813 5.78929C14.3813 7.00994 13.9613 8.02299 13.0978 8.88677C12.234 9.75054 11.2208 10.1703 10.0004 10.1703C8.78017 10.1703 7.76714 9.75035 6.90322 8.88677C6.03947 8.02318 5.61952 7.00994 5.61952 5.78929C5.61952 4.56901 6.03947 3.55577 6.90322 2.692Z" fill="white"/>
<path d="M19.9515 18.5652C19.9192 18.089 19.8537 17.5697 19.7573 17.0212C19.66 16.4687 19.5347 15.9463 19.3848 15.4689C19.2297 14.9755 19.0191 14.4882 18.7585 14.0212C18.4884 13.5365 18.1709 13.1145 17.8146 12.7672C17.4421 12.4038 16.9859 12.1117 16.4585 11.8986C15.9328 11.6867 15.3503 11.5793 14.7272 11.5793C14.4825 11.5793 14.2458 11.6816 13.7888 11.9849C13.5075 12.1719 13.1785 12.3882 12.8112 12.6273C12.4972 12.8313 12.0718 13.0224 11.5464 13.1954C11.0337 13.3644 10.5132 13.4502 9.99927 13.4502C9.48571 13.4502 8.9652 13.3644 8.45218 13.1954C7.92728 13.0225 7.50169 12.8315 7.18821 12.6275C6.82444 12.3906 6.49524 12.1743 6.20974 11.9847C5.75306 11.6814 5.5164 11.5791 5.27169 11.5791C4.64839 11.5791 4.06606 11.6867 3.54061 11.8988C3.01352 12.1115 2.5572 12.4036 2.18428 12.7673C1.82801 13.1148 1.51051 13.5367 1.24056 14.0212C0.980302 14.4882 0.769611 14.9753 0.614518 15.4691C0.464729 15.9465 0.339448 16.4687 0.242149 17.0212C0.145582 17.5689 0.0802897 18.0885 0.0479178 18.5657C0.0160945 19.0323 0 19.5179 0 20.0086C0 21.2841 0.397791 22.3167 1.18222 23.0782C1.95695 23.8296 2.98188 24.2107 4.22865 24.2107H15.7713C17.0178 24.2107 18.0427 23.8296 18.8176 23.0782C19.6022 22.3172 20 21.2843 20 20.0084C19.9998 19.5161 19.9835 19.0305 19.9515 18.5652ZM17.849 22.0408C17.3371 22.5374 16.6575 22.7788 15.7712 22.7788H4.22865C3.34217 22.7788 2.66255 22.5374 2.15081 22.0409C1.64877 21.5538 1.4048 20.8889 1.4048 20.0086C1.4048 19.5508 1.41961 19.0987 1.44924 18.6647C1.47814 18.2389 1.53721 17.7712 1.62481 17.2742C1.71132 16.7834 1.82142 16.3227 1.95237 15.9057C2.07802 15.5058 2.24939 15.1099 2.46191 14.7285C2.66474 14.365 2.89811 14.0531 3.15562 13.8018C3.39649 13.5667 3.70009 13.3743 4.05783 13.23C4.38868 13.0966 4.7605 13.0235 5.16415 13.0125C5.21334 13.0391 5.30095 13.09 5.44287 13.1844C5.73166 13.3762 6.06452 13.595 6.4325 13.8346C6.8473 14.1041 7.38171 14.3476 8.02019 14.5577C8.67293 14.7728 9.33866 14.8821 9.99945 14.8821C10.6602 14.8821 11.3262 14.7728 11.9785 14.5579C12.6176 14.3474 13.1518 14.1041 13.5671 13.8342C13.9437 13.5889 14.2672 13.3764 14.556 13.1844C14.698 13.0902 14.7856 13.0391 14.8348 13.0125C15.2386 13.0235 15.6104 13.0966 15.9414 13.23C16.299 13.3743 16.6026 13.5669 16.8435 13.8018C17.101 14.0529 17.3343 14.3648 17.5372 14.7287C17.7499 15.1099 17.9214 15.506 18.0469 15.9055C18.178 16.3231 18.2883 16.7836 18.3746 17.274C18.4621 17.7719 18.5213 18.2399 18.5502 18.6649V18.6653C18.58 19.0976 18.595 19.5495 18.5952 20.0086C18.595 20.8891 18.351 21.5538 17.849 22.0408Z" fill="white"/>
</svg>
                  Espace client</span>
              </button> */}
            </Nav.Link>
            <NavDropdown
              className={langue === "ar" ? "menu with_dropdown langue langue-ar" : "menu with_dropdown langue"}
              title={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src={flagImages[langue]}
                    alt={langue}
                    style={{ width: 24, height: 24, marginRight: 8 }}
                  />
                  <span>{langue.toUpperCase()}</span>
                </div>
              }
              show={false}
              onMouseEnter={() => setDropdownVisible(true)}
              onMouseLeave={() => setDropdownVisible(false)}
              onClick={() => closeMenuAPropos()}
            >
              {/* {languesAffichees.map((lang, index) => (
                <React.Fragment key={lang.code}>
                  <NavDropdown.Item
                    as={Link}
                    to={`/${lang.code}${url}`}
                    onClick={() => (ChangeLangue(lang.code), setExpanded(expanded ? false : "expanded"))}
                  >
                    <img src={lang.image} alt={lang.label} style={{ width: 24, height: 24, marginRight: 8 }} />
                    <span>{lang.label}</span>
                  </NavDropdown.Item>
                  {index < languesAffichees.length - 1 && (
                    <hr style={{ height: "1px", width: "61px", margin: "7px 12px" }} />
                  )}
                </React.Fragment>
              ))} */}
            </NavDropdown>

          </Nav>
        </Navbar.Collapse>
      </Navbar>
      {!isHome && (
        <div className="line" ></div>
      )}
    </>
  );

}
export default withTranslation()(NavBar)